<template>
    <div class="d-flex flex-column justify-content-between align-items-center">
      <h6>{{inspection.inspectionType}}</h6>

      <div v-if="!forProjectMarker" class="text-center pb-3">
        {{ inspection.projectName }}
      </div>

      <div v-if="inspection.reinspection" class="d-flex">
        <span><strong>Reinspection &nbsp;</strong></span>

        <span v-if="inspection.mostRecentAvailableInspectorForReinspection">
          (Previous Inspector: {{ inspection.mostRecentAvailableInspectorForReinspection.name}})
        </span>

        <span v-else>
          (No Previous Inspector available on this date)
        </span>
      </div>

      <div class="d-flex">
        Assigned Inspector:&nbsp;<strong>{{inspection.assignedInspector.name}}</strong> &nbsp;
        <div v-if="inspection.manuallyAssignedInspector">
          <span v-if="inspection.manuallyAssignedInspector.id === inspection.assignedInspector.id">
            (Manually Assigned)
          </span>

          <span v-else>
            (Manual Assignment: <strong>{{inspection.manuallyAssignedInspector.name}}</strong> was overridden by AI routing.
          </span>
        </div>
      </div>

      <button v-if="!isSimulation"
              class="btn btn-sm btn-primary w-50 mb-0"
              @click.prevent="changeAssignment"
      >
        Change
      </button>
    </div>
</template>

<script>
import {notifyError} from '@/utilities/utils'

export default {
  props: ['inspection', 'vue', 'forProjectMarker'],
  computed: {
      isSimulation() {
        return this.vue.$store.get('inspectorRouting/solverParams@isSimulation')
      }
  },
  methods: {
    changeAssignment() {
      const inspection = this.vue.$store.get('inspectorRouting/results').find(insp => insp.ptracTaskId === this.inspection.ptracTaskId)

      if (!inspection) {
        return notifyError(this, "Couldn't find the inspection with id: " + this.inspection.ptracTaskId)
      }

      this.vue.$eventHub.$emit('show-modal-1', "Change Assignment", inspection, '800px')
    },
  }
}
</script>
